export default (host: string) => ({
  '@id': 'organization',
  'areaServed': 'CA',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/fr-ca#brand`,
    'name': 'Timberland',
    'description': 'Timberland CA salue l’audace. Nos produits inspirent les personnes qui, par leurs idées novatrices, font avancer le monde.',
    'url': `https://${host}/fr-ca`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '+1-888-802-9947',
      'contactType': 'Téléphone',
      'areaServed': 'CA',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 08:30-17:00 EST'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Clavarder',
      'areaServed': 'CA',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 08:30-17:00 EST',
      'url': `https://${host}/fr-ca`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/fr-ca`
})
